import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiSetUserContactProfile } from "@/api";
import type { SetUserContactProfileRequest } from "@/api/types";
import { USER_CONTACT_PROFILE_QUERY_KEY } from "./useGetUserContactProfile";

export function useSetUserContactProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: SetUserContactProfileRequest) => {
      const res = await ApiSetUserContactProfile(data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: USER_CONTACT_PROFILE_QUERY_KEY,
      });
    },
  });
}
